import "core-js/modules/es.array.index-of";
import "core-js/modules/es.function.name";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import router from './router';
import { store } from '@/store';
import getPageTitle from '@/utils/page';
var asyncRouterFlag = 0;
var whiteList = ['Login', 'Init'];
router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var token, asyncRouters;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            token = store.getters['user/token']; // 在白名单中的判断情况
            // 修改网页标签名称

            document.title = getPageTitle(to.meta.title);

            if (!(whiteList.indexOf(to.name) > -1)) {
              _context.next = 13;
              break;
            }

            if (!token) {
              _context.next = 10;
              break;
            }

            if (store.getters['user/userInfo'].authority.defaultRouter) {
              _context.next = 7;
              break;
            }

            _context.next = 7;
            return store.dispatch('user/GetSysUser');

          case 7:
            next({
              name: store.getters['user/userInfo'].authority.defaultRouter
            });
            _context.next = 11;
            break;

          case 10:
            next();

          case 11:
            _context.next = 30;
            break;

          case 13:
            if (!token) {
              _context.next = 29;
              break;
            }

            if (!(!asyncRouterFlag && store.getters['router/asyncRouters'].length === 0)) {
              _context.next = 28;
              break;
            }

            asyncRouterFlag++;
            _context.next = 18;
            return store.dispatch('user/GetSysUser');

          case 18:
            _context.next = 20;
            return store.dispatch('router/SetAsyncRouter');

          case 20:
            asyncRouters = store.getters['router/asyncRouters'];
            console.log('permission.js asyncRouters', asyncRouters);
            router.addRoutes(asyncRouters);
            _context.next = 25;
            return store.dispatch('stations/SetAsyncStations');

          case 25:
            next(_objectSpread(_objectSpread({}, to), {}, {
              replace: true
            }));
            _context.next = 29;
            break;

          case 28:
            if (to.matched.length) {
              next();
            } else {
              next({
                path: '/layout/404'
              });
            }

          case 29:
            // 不在白名单中并且未登陆的时候
            if (!token) {
              next({
                name: 'Login',
                query: {
                  redirect: document.location.hash
                }
              });
            }

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());